import script from "./TranspressInitiative2026View.vue?vue&type=script&setup=true&lang=js"
export * from "./TranspressInitiative2026View.vue?vue&type=script&setup=true&lang=js"

import "./TranspressInitiative2026View.vue?vue&type=style&index=0&id=6b7c3d23&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6b7c3d23"]])

export default __exports__